import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Link2, X, MousePointerClick } from "lucide-react";
import { api } from "@/lib/api";

export const PAGE_LINKS = [
  ["/community-unterstuetzen", "Projekt unterstützen"], ["/community-unterstuetzen#mystery-box", "Mystery-Box"], ["/spiele", "Spiele"], ["/lotto", "Punkte-Lotto"],
  ["/haustier", "Mein Haustier"], ["/spielplatz", "Haustier-Spielplatz"], ["/teams", "Team Saskia vs. Stefan"], ["/stimmung", "Tagebuch & Stimmung"],
  ["/geschenke", "Geschenke-Shop"], ["/einladen", "Freunde einladen"], ["/rangliste", "Rangliste"],
  ["/ruhmeshalle", "Ruhmeshalle"], ["/community", "Community"], ["/nachrichten", "Nachrichten"], ["/push", "Push-Nachrichten aktivieren"],
  ["/profil", "Mein Profil"], ["/dashboard", "Meine Punkte"], ["/menu", "Menü"],
];

export const PostButtonStats = ({ stats, postId }) => stats ? (
  <p className="text-xs text-slate-500 flex items-center gap-1.5" data-testid={`post-button-stats-${postId}`}>
    <MousePointerClick className="w-3.5 h-3.5 text-rose-500 shrink-0" />
    <span><b className="text-slate-700">{stats.clicks}</b> {stats.clicks === 1 ? "Klick" : "Klicks"} · <b className="text-slate-700">{stats.users}</b> {stats.users === 1 ? "Person" : "Personen"} <span className="text-slate-400">· nur für Admins & Mods sichtbar</span></span>
  </p>
) : null;

export const PostButtonView = ({ button, postId }) => button ? (
  <Link to={button.url} data-testid={`post-button-${postId}`} onClick={() => { if (postId !== "preview") api.post(`/feed/posts/${postId}/button-click`).catch(() => {}); }}
    className="inline-flex items-center gap-2 h-11 px-5 rounded-full pink-gradient text-white font-bold text-sm shadow-md shadow-rose-200 hover:-translate-y-0.5 transition-transform">
    {button.label} <ArrowRight className="w-4 h-4" />
  </Link>
) : null;

export function PostButtonEditor({ value, onChange }) {
  const [custom, setCustom] = useState(false);
  if (!value) return null;
  const pick = (url) => { const d = PAGE_LINKS.find(([u]) => u === url); onChange({ url, label: custom ? value.label : (d ? `Zu ${d[1]}` : value.label) }); };
  return (
    <div className="rounded-2xl border border-pink-100 bg-rose-50/40 p-3 space-y-2" data-testid="composer-button-editor">
      <div className="flex items-center justify-between">
        <p className="text-xs font-bold text-rose-600 flex items-center gap-1.5"><Link2 className="w-4 h-4" /> Button zu einer Seite</p>
        <button onClick={() => onChange(null)} aria-label="Button entfernen" data-testid="composer-button-remove" className="w-7 h-7 rounded-full hover:bg-white flex items-center justify-center text-slate-500"><X className="w-4 h-4" /></button>
      </div>
      <div className="grid sm:grid-cols-2 gap-2">
        <select value={value.url} onChange={(e) => pick(e.target.value)} data-testid="composer-button-page" className="h-10 px-3 rounded-xl border border-pink-200 bg-white text-sm">
          {PAGE_LINKS.map(([u, l]) => <option key={u} value={u}>{l}</option>)}
        </select>
        <input value={value.label} maxLength={40} onChange={(e) => { setCustom(true); onChange({ ...value, label: e.target.value }); }} placeholder="Button-Text" data-testid="composer-button-label" className="h-10 px-3 rounded-xl border border-pink-200 bg-white text-sm" />
      </div>
      <div className="pt-1"><span className="text-[11px] text-slate-400 mr-2">Vorschau:</span><PostButtonView button={value.label.trim() ? value : null} postId="preview" /></div>
    </div>
  );
}
